import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { WIZ_COMMAND_STATE, WIZ_EVENT_TYPE,  
  CONFIRMATION_MODE, CONFIRMATION_RESULT, FILTER_TYPE, WizMathUtils, } from '@wizeoo/akm-core-lib';
import { ConfirmationResultObj, FilterComponent, WizButton, WizDatasource, 
  WizFocusManager, WizGroupCommand, WizIcon, WizPopUp, WizTextInput, WizValidationContainerDirective, WizValidationError, 
  WizValidationErrors, WizValidatorFn, WizVgroup, WizTranslationBasic, WizLabel, WizImage, WizTree, WizList, FilterObj, 
  BATCH_FILE_FORMAT, WizEventManager, WizEvent } from '@wizeoo/akm-component-lib';
import { MultiDisplay, MultiDisplayConfig, ScenarioStepParameterVO, ScenarioVO, StyleEngine } from '@wizeoo/akm-common-lib';
import { PermissionAccess, PermissionVisibility, StaticFeatureEnum, ViewPermission } from '@wizeoo/akm-common-lib';
import { AgLabelValidityRenderer } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { UserContextService } from '@wizeoo/akm-common-lib';
import { BATCH_KIND } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE, VISION_PROPERTY } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { ViewData } from '@wizeoo/akm-common-lib';
import { VisionThumbRenderer } from '../vision/renderer/vision-thumb.renderer';
import { ChronocodeCmd } from '@wizeoo/akm-common-lib';
import { FreedataCall } from '@wizeoo/akm-common-lib';
import { ScenTreeRenderer } from './scen-tree.renderer';
import { ScenStepRenderer } from './scen-step.renderer';
import { CellClickedEvent, ColDef } from '@ag-grid-community/core';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { ColorPickerPop } from '@wizeoo/akm-common-lib';
import { FindScenariiCommand } from '@wizeoo/akm-common-lib';
import { ScenarioStatsCmd } from '@wizeoo/akm-common-lib';
import { DeleteScenariiCommand } from '@wizeoo/akm-common-lib';

/**
 * Vue de gestion des grilles de poids
 */
@Component({
  selector: 'scenario-view',
  templateUrl: './scenario.view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScenarioView extends BaseView {
  // zone détail
  @ViewChild('vgDetailZone', { read: WizVgroup, static: false }) vgDetailZone: WizVgroup;
  @ViewChild('vgDetailZone', { read: WizValidationContainerDirective, static: false, }) private vgDetailZoneValidator: WizValidationContainerDirective;

  /** display des visions disponibles */
  @ViewChild('multiDisp', { read: MultiDisplay }) multiDisp: MultiDisplay<VisionVO>;

  /** rendu de la vision */
  @ViewChild('lblTitle', { read: WizLabel }) lblTitle: WizLabel;
   @ViewChild('uploadImg', { read: WizImage }) uploadImg: WizImage;
  /** Bouton de sauvegarde */
  @ViewChild('btnSave', { read: WizButton }) btnSave: WizButton;
  /** Bouton d'annulation de saisie */
  @ViewChild('btnCancel', { read: WizButton }) btnCancel: WizButton;

  /** Arbre des éléments */
  @ViewChild('treeScen', { read: WizTree, static: false }) treeScen: WizTree<ScenarioVO>;
  /** le composant de filtre du tree  */
  @ViewChild('scenFilter', { read: FilterComponent, static: false }) scenFilter: FilterComponent;

  /** Zone de validation des champs de saisie de l'élément */
  @ViewChild('vgEditValue', { read: WizValidationContainerDirective, static: false }) private vgEditValueContainer: WizValidationContainerDirective;

  /** Text input de saisie du code */
  @ViewChild('tiCode', { read: WizTextInput }) tiCode: WizTextInput;
  /** Composant de saisie du libellé traductible */
  @ViewChild('trsLabel', { read: WizTranslationBasic }) trsLabel: WizTranslationBasic;
  /** Composant de saisie de la description */
  @ViewChild('trsDesc', { read: WizTranslationBasic }) trsDesc: WizTranslationBasic;
  /** le scenario est principal */
  // @ViewChild('cbMain', { read: WizCheckbox }) cbMain: WizCheckbox;
  // /** le scenario est partagé (visible pour autre que le user) */
  // @ViewChild('cbShared', { read: WizCheckbox }) cbShared: WizCheckbox; 

  /** Button d'ajout de scenario sur 1er step */
  @ViewChild('btnAddScen', { read: WizIcon }) btnAddScen: WizIcon;

  /** couleur des barres de menus */
  @ViewChild('blockBack') blockBack: ElementRef; // zone de dessin de la couleur de background
  // listes des params de steps
  @ViewChild('stepList', { read: WizList }) stepList: WizList;

  /** Renderer du tree des scenarii */
  public valuesTreeRenderer: any = ScenTreeRenderer;

  public stepScenParamRenderer: any = ScenStepRenderer; 

  public currentVision: VisionVO = null; // vision en cours, sert aussi de flag pour afficher le détail / le cartouche
  public currentScenarii: ScenarioVO[] = null; // les scenarii de cette vision (les vrais, pas des clones)
  public clones: ScenarioVO[] = null; // une pile de clone des currentScenarii. C'est là-dessus qu'on travaille
  // public currentScen: ScenarioVO = null; // scen en cours, sert aussi de flag pour afficher le détail / le cartouche
  public clone: ScenarioVO = null; // le clone de travail


  /** datasource du display des visions */
  public visionDS: WizDatasource<VisionVO> = new WizDatasource<VisionVO>([])
    .setSortFields([{ property: 'code', way: 'asc' }])
    .setFilter(this.visionFilterFunc.bind(this))
    .build();

  /**
   * filtre la liste des visions pour masquer les visions de conf (BU)
   * @param item visionVO
   * @returns boolean, true si l'element correspond au filtre, false sinon
   */
  private visionFilterFunc(item: VisionVO): boolean {
    if(Model.getInstance().visionEngine.getVisionProperties(item, VISION_PROPERTY.ISCONFIGAPP)) {
      return false;
    }
    return true;
  }

  /** Data source de l'arbre des scenarii */
  public scenDS: WizDatasource<ScenarioVO> = new WizDatasource<ScenarioVO>([])
    .setHierarchical(true)
    .setItemCodeField('code')
    .setItemParentCodeField('parentCode')
    .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
    .setFilter(this.scenFilterFunc.bind(this))
    .setSelectionMode('single')
    .build();

  /** datasource du display des visions */
  public stepParamDS: WizDatasource<ScenarioStepParameterVO> = new WizDatasource<ScenarioStepParameterVO>([])
    .setSortFields([{ property: 'level', way: 'asc' }])
    .setSelectionMode('none')
    .build();

  // colonne du grid des roles disponibles
  public stepColumns: ColDef[] = [
    { headerName: '$.common.label.$', flex: 1, field: 'trsLabel' },
    { headerName: '$.scen.visible.$', width: 60, field: 'visible', cellRenderer: (params) => this.stepParamRenderer('visible', params.data), cellClass: 'cbox-cell', type: 'boolean' },
    { headerName: '$.scen.editable.$', width: 60, field: 'editable', cellRenderer: (params) => this.stepParamRenderer('editable', params.data), cellClass: 'cbox-cell', type: 'boolean' },
    { headerName: '$.visionstep.lines.$', field: 'nbBL', width: 60,  },
    { headerName: '$.visionstep.values.$', field: 'nbBLV', width: 60 },
  ];

  private stepParamRenderer(prop: string, param: ScenarioStepParameterVO): string {
    if (!this.clone) {
      return `<i class="fa-regular fa-square"></i>`;
    }

    if (prop === 'visible') {
      if (param.visible) {
        return `<i class="fa-regular fa-square-check"></i>`;
      } else {
        return `<i class="fa-regular fa-square"></i>`;
      }
    } 
    else if (prop === 'editable') {
      if (param.editable) {
        return `<i class="fa-regular fa-square-check"></i>`;
      } else {
        return `<i class="fa-regular fa-square"></i>`;
      }
    } 
  }


  /**
   * Fonction de filtre de la liste des scenarii
   * @param item Elément testé pour le filtre
   */
  private scenFilterFunc(item: ScenarioVO): boolean {
    return this.scenFilter.checkVisible(item);
  }


  /* ##############################################################################
                    Panneau gauche : Liste, sélection, filtres
     ############################################################################## */

  /**
   * configuration de l'affichage des visions
   */
  public multiDisplayConfig: MultiDisplayConfig<VisionVO> = {
    model: Model.getInstance(),
    datasource: this.visionDS,
    defaultMode: 'grid',
    onSelectionChanging: this.onVisionChange.bind(this),
    grid: {
      enabled: true,
      columns: [
        {
          headerName: ' ',
          field: 'code',
          width: 40,
          sortable: false,
          cellRenderer: 'visionThumbRenderer'
        },
        {
          headerName: '$.common.code.$',
          field: 'code',
          tooltipField: 'code',
          width: 100,
          sortable: true,
        },
        {
          headerName: '$.common.label.$',
          field: 'trsLabel',
          tooltipField: 'trsLabel',
          flex: 1,
          cellRenderer: 'labelValidityRenderer',
          sortable: true,
        },
      ],
      renderers: {
        labelValidityRenderer: AgLabelValidityRenderer, visionThumbRenderer: VisionThumbRenderer
      },
    },
    filter: {
      enabled: true,
      initFilter: this.initFilter.bind(this),
    },
  };

  private mainFilter: FilterComponent;

  private initFilter(pFilter: FilterComponent): FilterComponent {
    this.mainFilter = pFilter;
    return this.mainFilter;
  }

  /** accesseur sur le contexte */
  private get _context(): UserContextService {
    return Model.getInstance().userContextService;
  }

  /* #############################################################
                        CYCLE DE VIE
     ############################################################# */

  constructor(elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super(elementRef);
  }

  /**
   * Pretraitement: chargement des données nécessaires à la vue
   * @return WizGroupCommand
   */
  public wizBeforeInit(): WizGroupCommand {
	super.wizBeforeInit();
    const commands = [];
    
    // disponibilité des chronocodes pour labels
    if (!Model.getInstance().chronocodeEngine.getChronocodesMap()) {
      commands.push(new ChronocodeCmd(Model.getInstance()).find());
    }

    // disponibilité des freedatas pour labels
    if (!Model.getInstance().freedataEngine.getFreedataMap()) {
      commands.push(new FreedataCall(Model.getInstance()));
    }
    
    // disponibilité des scenarii
    // if (!Model.getInstance().scenariiMap) {
      commands.push(new FindScenariiCommand(Model.getInstance()));
    // }

    if (commands.length > 0) {
      return new WizGroupCommand().configure(commands);
    } else {
      return null;
    }
  }

  /** gestion des permission de la vue */
  private get viewPermissions(): ViewPermission[] {
    return [
      {
        feature: StaticFeatureEnum.SCENARIO,
        permissions: [
          {
            component: this.btnAddScen,
            accesses: [PermissionAccess.CREATE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.vgDetailZone,
            accesses: [PermissionAccess.UPDATE, PermissionAccess.CREATE],
            visibility: PermissionVisibility.DISABLED,
          },
        ],
      },
    ];
  }

  /**
   * Mise en place des écouteurs
   */
  public wizAddListener(): void {
	super.wizAddListener();
    // merge (create / update sur btnSave)
    WizEventManager.addListener(this, this.btnSave, WIZ_EVENT_TYPE.CLICK, this.doMerge);
    // revert (btCancel)
    WizEventManager.addListener(this, this.btnCancel, WIZ_EVENT_TYPE.CLICK, this.doRevert);
    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);

    // écouteur sur focusOut de la zone code. En cas de changement, impact sur la structure du tree
    WizEventManager.addListener(this, this.tiCode, WIZ_EVENT_TYPE.FOCUS_OUT, this.checkCodeUpdate);

    // changement de sélection dans le tree, mode capture pour éventuelle interception
    WizEventManager.addListener(this, this.treeScen, WIZ_EVENT_TYPE.SELECTION_CHANGING, this.askSelectScen, {capture: true});
    // changement de sélection dans le tree, effectif
    WizEventManager.addListener(this, this.treeScen, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.selectScen);
    // Listener sur l'evenement ALK_EVENT_ADD emis lors de la demande de création d'un scen
    WizEventManager.addListener(this, this.treeScen, ALK_EVENT_TYPE.ADD, this.addScen);
    // Listener sur l'evenement ALK_EVENT_DELETE emis lors de la demande de suppression d'un scen
    WizEventManager.addListener(this, this.treeScen, ALK_EVENT_TYPE.DELETE, this.askdeleteScen);

    // application du filtre sur tree
    WizEventManager.addListener(this, this.scenFilter, WIZ_EVENT_TYPE.CHANGE, this.refreshTree);

  }

  /**
   * Suppression des écouteurs
   */
  public wizRemoveListener(): void {
	super.wizRemoveListener();
    // merge (create / update sur btnSave)
    WizEventManager.removeListener(this, this.btnSave, WIZ_EVENT_TYPE.CLICK);
    // revert (btCancel)
    WizEventManager.removeListener(this, this.btnCancel, WIZ_EVENT_TYPE.CLICK);
    WizEventManager.removeListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, this.tiCode, WIZ_EVENT_TYPE.FOCUS_OUT);


    // changement de sélection dans le tree, mode capture pour éventuelle interception
    WizEventManager.removeListener(this, this.treeScen, WIZ_EVENT_TYPE.SELECTION_CHANGING);
    // changement de sélection dans le tree, effectif
    WizEventManager.removeListener(this, this.treeScen, WIZ_EVENT_TYPE.SELECTION_CHANGED);
    // Listener sur l'evenement ALK_EVENT_ADD emis lors de la demande de création d'un scen
    WizEventManager.removeListener(this, this.treeScen, ALK_EVENT_TYPE.ADD);
    // Listener sur l'evenement ALK_EVENT_DELETE emis lors de la demande de suppression d'un scen
    WizEventManager.removeListener(this, this.treeScen, ALK_EVENT_TYPE.DELETE);

    // application du filtre sur tree
    WizEventManager.removeListener(this, this.scenFilter, WIZ_EVENT_TYPE.CHANGE);
  }

  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {

    /** alimentation de la DS des visions */
    this.visionDS.setSource([...Model.getInstance().visionEngine.visionDS.getSource()]);

    /** alimentation de l'arbre des scens */
    // this.scenDS.setSource([...Model.getInstance().scenariiList]);

    // construction des filtres du grid
    this.buildFilter();
    this.tiCode.wizRestrict = ViewData.CODE_REGEXP; // restriction sur le code des scenarii

    if(!!this.currentVision) { // ce n'est pas mon premier passage...
      this.feed();
    }

  }

  /**
   * construction de la zone de filtre des visions et des scenarii
   * @param event : Evenement de changement dans le text input de filtre
   */
  private buildFilter(event: WizEvent = null): void {
    this.mainFilter.configure(['code', 'trsLabel'], null, null);
    // le contextEngine prend le relais pour alimenter les filtres par défaut
    this._context.feedFilterContext(this.mainFilter);

    const filter = []; // alimentation du filtre
    filter.push(FilterObj.create('enterpriseMode', '$.scen.kind.enterprise.$', FILTER_TYPE.BOOLEAN, true, 1));
    filter.push(FilterObj.create('userMode', '$.scen.kind.user.$', FILTER_TYPE.BOOLEAN, true, 2));
    this.scenFilter.configure(['code', 'trsLabel'], null, Array.from(filter)).build();
    
    // le contextEngine prend le relais pour alimenter les filtres par défaut
    this._context.feedFilterContext(this.scenFilter, 'SCEN_FILTER');
  }


  /* #########################################
              Sélection d'une vision
     ######################################### */

  /**
   * Callback de selection de la vision
   * @param pEvent WizEvent
   */
  private onVisionChange(e: WizEvent): void {
    
    let vision: VisionVO = e.value;
    // console.log('vision', vision);
    
    // empêche le changement de selection quand il y a une modification de model en cours
    if (ViewData.wizUpdateModel) {
      // on stop le fonctionnement par défaut pour afficher la pop, on sélectionnera l'item seulement si le user confirme
      e.preventDefault();
      if(!this.visionDS.isSelected(vision)) { // on demande un changement. Sinon, c'est selfClick
        WizPopUp.confirm(
          '$.common.pending.update.title.$',
          '$.common.pending.update.detail.$',
          this.confirmSwapVision.bind(this),
          CONFIRMATION_MODE.CONFIRM_CANCEL,
          vision
        ).show();
      }
    } else {
      if (!this.visionDS.isSelected(vision)) {   
        this.doSelectVision(vision); // pas encore sélectionné
      } else {
        this.doSelectVision(null); // déjà sélectionné, déselection
      }
    }
    this.cdref.markForCheck();
  }

  /**
   * Confirmation de la sélection de la vision
   * @param result: Objet ConfirmationResultObj contenant le choix effectué sur la popup
   */
  private confirmSwapVision(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      this.visionDS.toggle(result.data);
      this.doSelectVision(result.data);
    }
  }

  /** application de la sélection de vision */
  private doSelectVision(vo: VisionVO) {
    this.currentVision = vo;
    this.resetModelUpdate(); // plus de modifs en cours
    this.resetSelectedScen(); // on rince la sélection de scenario
    this.feed(); // on alimente le détail
  }

  /** gestion de la visibilité de la zone détail */
  public get isDetailVisible() {
    const result =
      !!this.currentVision &&
      Model.getInstance().permissionEngine.hasAnyPermission({
        feature: StaticFeatureEnum.SCENARIO,
        accesses: [PermissionAccess.READ, PermissionAccess.CREATE, PermissionAccess.UPDATE],
        visibility: PermissionVisibility.DISABLED,
        });
      return result;
    }  


  /**
   * Initialisation des valeurs des champs dans le conteneur d'edition en fonction du currentCountry
   */
  public feed(): void {
    
    // alimentation du détail de la vision
    if(!!this.currentVision) {
      
      // ScenarioEngine.buildScenarioDeps(this.currentVision.code);
      
      this.lblTitle.wizLabel = Model.getInstance().visionEngine.getVisionLabel(this.currentVision) + ' (' + this.currentVision.code + ')';
      this.uploadImg.sourceObservable = Model.getInstance().visionEngine.getVisionIconOrDie(this.currentVision);

      // construction de l'arbre des scen
      this.currentScenarii = Model.getInstance().scenarioEngine.getScenarioByVision(this.currentVision.code); // les scenarii réels
      this.clones = [...Model.getInstance().scenarioEngine.cloneAll(this.currentScenarii)]; // la collection de clone de travail

      this.scenDS.setSource(this.clones); // alimentation de la DS
      this.treeScen.wizDataProvider = this.scenDS; // alimentation de l'arbre
      this.scenDS.expandAll();
    }

    this.cdref.markForCheck();
  }


  /* #########################################
            gestion des scenarii
     ######################################### */


  /** annulation de la sélection de scenario sur chgt vision */   
  private resetSelectedScen(): void {
    this.currentScenarii = null;
    this.clones = null; // la coll de clones
    this.clone = null; // l'éventuel clone actif
  }

  /**
   * affichage de la zone d'édition des scens
   * @returns 
   */
  public get showScenEditZone(): boolean {
    return !!this.clone;
  }


  /** demande de changement de sélection de Scen, interception possible */
  private askSelectScen(e: WizEvent = null): void {
    const vo: ScenarioVO = e.value;

    const errors = this.clone ? this.vgEditValueContainer.check(true, true) : null;
    if (errors && errors.length > 0) {
      WizPopUp.toast('$.common.toast.pending.error.$', WizIcon.TOAST_ERROR).show();
      console.log('errors on fields', this.clone);
      e.preventDefault();
    }
  }

  /**
   * Sélection effective d'un scen
   * @param pEvent, wizEvent contenant la valeur
   */
  private selectScen(pEvent: WizEvent): void {
    this.clone = pEvent.value && pEvent.value.length > 0 ? pEvent.value[0] : null;
    if(!!this.clone) {
      Model.getInstance().scenarioEngine.initParameters(this.clone, this.currentVision); // on s'assure que la liste des steps est complète
    
     
      let cmd = new ScenarioStatsCmd(Model.getInstance()).do(this.clone, this.statLoaded.bind(this));// chargement des stats
      cmd.execute();
    
    } else {
      this.feedScen();
    }
    
  }

  private statLoaded(e: ScenarioStatsCmd) {
    this.feedScen();
  }

  /** alimentation du détail du scenario */
  private feedScen(): void {

    if(!!this.clone) {
        
        // alimentation du code
        this.tiCode.wizValue = this.clone.code;
        this.tiCode.wizDisabled =
          this.clone.exist || !Model.getInstance().permissionEngine.hasAnyPermission({
            feature: StaticFeatureEnum.SCENARIO,
            accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
            visibility: PermissionVisibility.DISABLED,
          }); // édition du code

        // alimentation du libellé
        this.trsLabel.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.labelVO);
        this.trsDesc.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.descriptionVO);
        
        // couleur de la marque de scenario
        if (!!this.clone.color) {
          this.backgroundColor = this.clone.color;
        } else {
          this.backgroundColor = StyleEngine.STYLE_DEFAULT_SCEN_COLOR;
        }
        // construction du CSS actif
        this.css = StyleEngine.STYLE_BACKGROUND_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.backgroundColor;

        // alimentation de la liste des steps
        if(!!this.clone.stepParameters) {
          this.stepParamDS.setSource(this.clone.stepParameters.map(item => new ScenarioStepParameterVO(Model.getInstance(), item, this.currentVision, this.clone)));
        } else {
          this.stepParamDS.setSource([]);
        }

        


        // this.cbMain.wizChecked = true;
        // this.cbShared.wizChecked = true;

        // focus du premier champs actif
        this.focusFormFields();
    }

    this.cdref.markForCheck();
  }

  /**
   * autoriser la création de scenario
   */
  public get cantCreateValues(): boolean {
    return (
      !this.currentVision ||
      !Model.getInstance().permissionEngine.hasAnyPermission({
        feature: StaticFeatureEnum.SCENARIO,
        accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
        visibility: PermissionVisibility.DISABLED,
      })
    );
  }

  /**
   * focus du premier champs actif
   */
  public focusFormFields(): void {
    // focus du label si c'est une mise à jour
    if (this.clone.exist) {
      WizFocusManager.getInstance().wizSetFocus(this.trsLabel);
    } else {
      WizFocusManager.getInstance().wizSetFocus(this.tiCode);
    }
  }

  /** ajout d'un scenario de step 1 */
  public addFirstLevelScen(): void {
    this.addScen(null);
  }

 /**
   * Ajout d'un free data value
   * @param e Evenement ajout
   */
 private addScen(e: AlkEvent): void {
  if (e) {
    e.preventDefault();
  }

  const errors = this.clone ? this.vgEditValueContainer.check(true, true) : null;
  if (!errors || errors.length === 0) { // pas d'erreur, on ajoute un nouveau clone
    
    const parent: ScenarioVO = e ? e.data : null;
    const newScen: ScenarioVO = Model.getInstance().scenarioEngine.createChildScen(this.currentVision, parent, this.clones);
  
    this.clones.push(newScen); // ajout à la collection de travail
    this.clone = newScen; // sélection
    Model.getInstance().scenarioEngine.initParameters(this.clone, this.currentVision); // on s'assure que la liste des steps est complète
    this.scenDS.setSource(this.clones); // alimentation de la DS
    if(!!newScen.parentCode) { // expand si nécessaire
      const parent: ScenarioVO = this.scenDS.getItemByKey(newScen.parentCode);
      if(!!parent) {
        this.scenDS.expandNode(parent);
      }
      
    }
    this.scenDS.select([newScen]);
    this.treeScen.wizDataProvider = this.scenDS; // alimentation de l'arbre

    this.feedScen(); // alimentation du détail

    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    // this.manageComponents();
  } else {
    WizPopUp.toast('$.common.toast.pending.error.$', WizIcon.TOAST_ERROR).show();
  }
}

  /**
   * Validateur d'unicité du code de la vision
   */
  public uniqueCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      // Pas de gestion d'erreur si le currentChronocode est null
      if (this.clone === null || this.clone === undefined) {
        return null;
      }

      if (
        this.tiCode.wizValue !== null &&
        this.tiCode.wizValue &&
        this.tiCode.wizValue.length > 0 &&
        !this.clone.exist
      ) {

        if (this.tiCode.wizValue.toUpperCase() === ViewData.wildcardMainScenario // pas MAIN
        ) {
          const temp: WizValidationError = {
            wizError: '$.common.keyword.$',
            wizErrorParams: [],
          };
          return [temp];
        }
        
        // Recherche d'une autre avec le même code
        let other = new Map(this.clones.filter(item => item.uid !== this.clone.uid).map(item => [item.code, item])).get(this.tiCode.wizValue.toUpperCase());

        // Si la vision existe deja avec le meme code on affiche le message
        if (other) {
          const temp: WizValidationError = {
            wizError: '$.scen.error.code.unique.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  }

  /**
   * demande de suppression d'une scen value depuis le le tree
   * @param e evenement allkeyme
   */
  private askdeleteScen(e: AlkEvent): void {
    e.preventDefault(); // pas de sélection dans le tree
    
    if(!e.data.id) {// pas persisté, on supprime direct
      let cro: ConfirmationResultObj = ConfirmationResultObj.build(CONFIRMATION_RESULT.CONFIRM, e.data);
      this.doDelete(cro);
      return;
    }
    
    // TODO TODO suppression directe si existe pas
    let cmd = new ScenarioStatsCmd(Model.getInstance()).do(e.data, this.deleteScenCheck.bind(this));// chargement des stats
    cmd.execute();
    
    // this.deleteScen(e.data);
  }

  /**
   * contrôle avant suppression. Si présence de lignes ou de scenar enfant
   * @param call 
   */
  private deleteScenCheck(call: ScenarioStatsCmd): void {
    let scen: ScenarioVO = call.vo;

    if(!!Model.getInstance().scenarioEngine.getAllChildren(scen)) {// si scenarii enfants, warning
      // console.log('doDelete children', scen, ScenarioEngine.getAllChildren(scen));
      WizPopUp.confirm(
        '$.scenario.delete.$',
        '$.scenario.delete.haschild.$',
        this.doDelete.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        scen
      ).show();
    } else if (Model.getInstance().scenarioEngine.hasLines(scen)) {
      // console.log('doDelete haslines', scen, ScenarioEngine.hasLines(scen));
      WizPopUp.confirm(
        '$.scenario.delete.$',
        '$.scenario.delete.haslines.$',
        this.doDelete.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        scen
      ).show();
    } else {
      let cro: ConfirmationResultObj = ConfirmationResultObj.build(CONFIRMATION_RESULT.CONFIRM, scen);
      this.doDelete(cro);
      // console.log('doDelete', scen);
    }
  }

  // suppression réelle
  private doDelete(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      let scen: ScenarioVO = result.data;
      let toDieMap: Map<string, ScenarioVO> = Model.getInstance().scenarioEngine.getAllChildren(scen, true);
      
      if(!scen.id) {
        this.scenDS.removeChild(scen);
        this.clone = null; // il est mort... on masque le détail
      } else {
        let cmd = new DeleteScenariiCommand(Model.getInstance()).do(scen.visionCode, scen, [...toDieMap.values()], this.backFromDelete.bind(this));
        cmd.execute();
      }
 
    }
  }

  private backFromDelete(cmd: DeleteScenariiCommand): void {
    // console.log('backFromDelete', cmd);
    
    this.scenDS.removeChild(cmd.targetScenario);
    // et on synchronise les piles, pour éviter une erreur en cas de merge postérieur
    let toDieSet: Set<number> = new Set(cmd.scenarii.map(item => item.id || -1));

    // clones propres
    let newClones:ScenarioVO[] = [];
    // currentScenarii propre
    let newScenarii: ScenarioVO[] = [];

    this.clones.forEach(sc => {
      if(!toDieSet.has(sc.id)) {
        newClones.push(sc);
      }
    });
    this.currentScenarii.forEach(sc => {
      if(!toDieSet.has(sc.id)) {
        newScenarii.push(sc);
      }
    });

    this.clones = newClones;
    this.currentScenarii = newScenarii;
    this.clone = null; // il est mort... on masque le détail
    // this.cdref.markForCheck(); // et refresh visuel
  }

  /**
   * sur sortie d'édition du code. Alimentation correcte du ParentCode des enfants
   * et renconstruction du tree
   * @param e 
   */
  private checkCodeUpdate(e: WizEvent): void {
    // console.log('code focus out', e, this.tiCode.wizValue, this.clone.code, this.clone.initCode);
    if(this.clone.code !== this.clone.initCode) {
      let children: ScenarioVO[] = this.clones.filter(item => item.parentCode === this.clone.initCode);
    
      children.forEach(child => {
        child.parentCode = this.clone.code;
      });
      // et on met à jour le nouvel "initCode" du scenario en cours de modif
      this.clone.initCode = this.clone.code;
      this.scenDS.setSource(this.clones); // alimentation de la DS
      if(!!this.clone) { // expand si nécessaire
        this.scenDS.select([this.clone]);
      }
      this.treeScen.wizDataProvider = this.scenDS; // alimentation de l'arbre
    }
  }
  
  public doAct(action: string): void {
    switch (action) {
      case 'export':
        Model.getInstance().batchEngine.export(BATCH_KIND.SCENARIO, BATCH_FILE_FORMAT.JSON, this.currentVision.code);
        break;
      case 'import':
        Model.getInstance().batchEngine.import(BATCH_KIND.SCENARIO);
        break;
    }
  }

  /* #########################################
                    Detail
     ######################################### */




  /** desactivation des boutons save et cancel sur updateModel */
  public disableSave(): boolean {
    let result: boolean = true;
    result = !ViewData.wizUpdateModel;
    return result;
  }

  /** desactivation des boutons save et cancel sur updateModel */
  public disableCancel(): boolean {
    return !ViewData.wizUpdateModel;
  }




  /** demande de merge sur btOk */
  private doMerge(e: WizEvent): void {
    let errors = this.vgDetailZoneValidator.check(true, true);

    if (errors?.length > 0) {
      WizPopUp.toast('$.wg.error.$', WizIcon.TOAST_ERROR).show();    
    } else {
      Model.getInstance().scenarioEngine.merge(this.clones, this.currentScenarii, this.backFromMerge.bind(this));
    }
  }

  /**
   * Callback de modification des scenarii
   * @param result success / fault
   */
  private backFromMerge(updates: ScenarioVO[], result: WIZ_COMMAND_STATE): void {  
    if(result === WIZ_COMMAND_STATE.SUCCESS) {
      // on met à jour les vrais objets, pour comparaison
      this.currentScenarii = Model.getInstance().scenarioEngine.getScenarioByVision(this.currentVision.code); // les scenarii réels
      this.feed();

    } else { // erreur, on refresh tout
      this.feed();
    }
    this.resetModelUpdate();

  }

  /**
   * revert sur btCancel, simple resélection
   * @param e wizEvent
   */
  private doRevert(e: WizEvent): void {
    this.clone = null; // plus de sélection
    this.feed();
    this.resetModelUpdate();
  }

  /**
   * Modification du model dans la zone de saisie
   * @param e Evenement model change
   */
  private updateModel(e: WizEvent): void {
    // console.log('updateModel', e.value);
    let realUpdate: boolean = false; // le treeView dispatch comme un malade...
    switch (e.component) {
      case this.tiCode:
        this.clone.code = this.tiCode.wizValue?.toUpperCase();
        realUpdate = true;
        break;
      case this.trsLabel:
        this.clone.labelVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        realUpdate = true;
        break; 
      case this.trsDesc:
        this.clone.descriptionVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        realUpdate = true;
        break;
      // case this.cbMain:
      //   // this.clone.main = this.cbMain.wizChecked;
      //   realUpdate = true;
      //   break;
      // case this.cbShared:
      //   // this.clone.shared = this.cbShared.wizChecked;
      //   realUpdate = true;
      //   break;
    }

    if(realUpdate) {
      
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
      // console.log('real update', realUpdate, e);
      this.refreshTree();
      // this.cdref.markForCheck();
    }   
  }

  /** modification du filtre sur les FDV */
  private refreshTree(e: WizEvent = null): void {
    this.scenDS.refresh();
  }


  /**
   * mise à false du model update
   */
  public resetModelUpdate() {
    // on informe que le model n'a pas de changement en cours
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));
  }

 /* ##############################################################################
                   gestion du colorPicker pour la conf du header
     ############################################################################## */

     public backgroundColor = StyleEngine.STYLE_DEFAULT_SCEN_COLOR; // --grid-header-background-color
     public css: any = null;
   
     /**
      * affichage de la popUp du colorPicker
      * @param pEvent click
      */
     public showColorPicker(pEvent: Event): void {
       pEvent.stopPropagation();
       pEvent.preventDefault();
       ColorPickerPop.show(this.blockBack.nativeElement, pEvent.target, this.backgroundColor, this.backFromPicker.bind(this));
     }
   
     /**
      * retour de colorPicker, alimentation des couleurs du header
      *
      * @param target le span source pour font ou background
      * @param color la couleur du picker
      */
     public backFromPicker(target: any, color: string): void {
       this.backgroundColor = color;
       this.feedHeaderStyle();
     }
   
     /** alimentation des slots de couleurs pour le header */
     public feedHeaderStyle(): void {
       this.css = StyleEngine.STYLE_BACKGROUND_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.backgroundColor;
       this.clone.color = this.backgroundColor;
       WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
       this.cdref.markForCheck();
     }
   
     /** click sur les icones de suppression de style de header */
     public resetColor(who: string): void {
       this.backgroundColor = StyleEngine.STYLE_DEFAULT_BAR_COLOR; // --grid-header-background-color
       this.feedHeaderStyle();
     }

     public doStepConfiguration(event: CellClickedEvent) {
      if (event.colDef.field === 'visible') {
        (event.data as ScenarioStepParameterVO).visible = !(event.data as ScenarioStepParameterVO).visible;
        WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
      } else if(event.colDef.field === 'editable') {
        (event.data as ScenarioStepParameterVO).editable = !(event.data as ScenarioStepParameterVO).editable;
        WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
      }
      event.api.refreshCells({ force: true, rowNodes: [event.node], suppressFlash: true });
    }

}
